<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table :headers="headersTable1" :items="items" :search="search">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("services-table-top-t1") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="nuevoServicio()"
            :disabled="$store.state.usuario.rol == 'Solo Vista'"
          >
            {{ $t("services-table-top-btn1") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.activo`]="{ item }">
        <v-simple-checkbox v-model="item.activo" disabled></v-simple-checkbox>
      </template>

      <template v-slot:[`item.exento`]="{ item }">
        <v-simple-checkbox v-model="item.exento" disabled></v-simple-checkbox>
      </template>

      <template v-slot:[`item.no_sujeto`]="{ item }">
        <v-simple-checkbox
          v-model="item.no_sujeto"
          disabled
        ></v-simple-checkbox>
      </template>

      <template v-slot:[`item.con_iva`]="{ item }">
        <v-simple-checkbox v-model="item.con_iva" disabled></v-simple-checkbox>
      </template>

      <!-- Boton de editar -->
      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon class="mr-2" @click="editarServicio(item)">
          fa-solid fa-pen-to-square
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="cod_servicio"
                :label="$t('services-dialog-input-label1')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-checkbox
                :label="$t('services-dialog-checkbox1')"
                v-model="activo"
                hide-details="true"
                class="pa-0"
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="nom_servicio"
                :label="$t('services-dialog-input-label2')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="3" md="4">
              <v-text-field
                :label="$t('services-dialog-input-label3')"
                model-value="10.00"
                prefix="$"
                v-model="precio"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="auto">
              <v-checkbox
                :label="$t('services-dialog-checkbox2')"
                v-model="exento"
                hide-details="true"
                @change="estadoExento()"
              ></v-checkbox>
            </v-col>

            <v-col cols="auto">
              <v-checkbox
                :label="$t('services-dialog-checkbox3')"
                v-model="no_sujeto"
                hide-details="true"
                @change="estadoNoSujeto()"
              ></v-checkbox>
            </v-col>

            <v-col cols="auto">
              <v-checkbox
                :label="$t('services-dialog-checkbox4')"
                v-model="con_iva"
                hide-details="true"
                @change="estadoIVA()"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="crearServicio()"
            v-if="flag_new_edit == 1"
            :disabled="$store.state.usuario.rol == 'Solo Vista'"
            >{{ $t("btn-save") }}</v-btn
          >
          <v-btn
            color="primary"
            @click="actualizarServicio()"
            v-if="flag_new_edit == 2"
            :disabled="$store.state.usuario.rol == 'Solo Vista'"
            >{{ $t("btn-update") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">{{ $t("btn-close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="8000"
      color="blue"
      multi-line
      elevation="24"
      outlined
      top
      right
    >
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dialog: false,
    snackbar: false,
    icon_snackbar: "fa-solid fa-circle-info",
    snackbar_text: "...",
    items: [],
    cod_servicio_original: "",
    id_servicio: 0,
    cod_servicio: "",
    nom_servicio: "",
    exento: false,
    no_sujeto: false,
    con_iva: true,
    activo: true,
    precio: 0.0,
    id_emp: 0,
    flag_new_edit: 1,
    search: "",
  }),
  created() {
    //
  },
  computed: {
    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarServicios();
        return true;
      }
    },
    headersTable1() {
      return [
        { text: this.$t("services-table-header-t1"), value: "cod_servicio" },
        { text: this.$t("services-table-header-t2"), value: "nom_servicio" },
        {
          text: this.$t("services-table-header-t3"),
          value: "activo",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("services-table-header-t4"),
          value: "exento",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("services-table-header-t5"),
          value: "no_sujeto",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("services-table-header-t8"),
          value: "con_iva",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("services-table-header-t6"),
          value: "precio",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("services-table-header-t7"),
          value: "action_edit",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  methods: {
    listarServicios() {
      if (this.$store.state.emp.id_empresa != undefined)
        axios
          .get("api/Servicios/Listar/" + this.$store.state.emp.id_empresa)
          .then((response) => {
            this.items = response.data;
          });
    },
    nuevoServicio() {
      this.flag_new_edit = 1;
      this.limpiar();
      this.dialog = true;
    },

    async validarServicio(modo) {
      let xcodigo = "";
      let validar_cod_servicio = false;
      let mensaje_error = "";

      if (modo == 1) {
        xcodigo = this.cod_servicio;
        validar_cod_servicio = true;
      } else if (modo == 2) {
        if (this.cod_servicio != this.cod_servicio_original) {
          validar_cod_servicio = true;
        }
      }

      if (validar_cod_servicio == true) {
        let test = await axios.get(
          "api/servicios/ObtenerServicioPorCodigo/" +
            this.cod_servicio +
            "/" +
            this.$store.state.emp.id_empresa
        );
        if (test.data != "") {
          mensaje_error = this.$t("services-snackbar-t1") + " ";
        }
      }

      if (this.cod_servicio == "") {
        mensaje_error += this.$t("services-snackbar-t2") + " ";
      }

      if (this.nom_servicio == "") {
        mensaje_error += this.$t("services-snackbar-t3") + " ";
      }

      if (mensaje_error != "") {
        this.snackbar_text = mensaje_error;
        this.snackbar = true;
        return false;
      } else {
        return true;
      }
    },

    async crearServicio() {
      var es_valido = await this.validarServicio(1);

      if (es_valido == true) {
        axios
          .post("api/servicios/Crear", {
            id_empresa: this.$store.state.emp.id_empresa,
            cod_servicio: this.cod_servicio,
            nom_servicio: this.nom_servicio,
            activo: this.activo,
            exento: this.exento,
            no_sujeto: this.no_sujeto,
            con_iva: this.con_iva,
            precio: this.precio,
          })
          .then(() => {
            this.snackbar_text = this.$t("services-snackbar-t4");
            this.snackbar = true;

            this.cerrarDialog();
            this.listarServicios();
          })
          .catch(() => {
            this.snackbar_text = this.$t("services-snackbar-t5");
            this.snackbar = true;
          });
      }
    },
    editarServicio(item) {
      this.id_servicio = item.id_servicio;
      this.cod_servicio = item.cod_servicio;
      this.cod_servicio_original = item.cod_servicio;
      this.nom_servicio = item.nom_servicio;
      this.activo = item.activo;
      this.exento = item.exento;
      this.no_sujeto = item.no_sujeto;
      this.con_iva = item.con_iva;
      this.precio = item.precio;

      this.flag_new_edit = 2;
      this.dialog = true;
    },

    async actualizarServicio() {
      var es_valido = await this.validarServicio(2);

      if (es_valido == true) {
        axios
          .put("api/Servicios/Actualizar", {
            id_servicio: this.id_servicio,
            cod_servicio: this.cod_servicio,
            nom_servicio: this.nom_servicio,
            activo: this.activo,
            exento: this.exento,
            no_sujeto: this.no_sujeto,
            con_iva: this.con_iva,
            precio: this.precio,
            id_empresa: this.$store.state.emp.id_empresa,
          })
          .then(() => {
            this.snackbar_text = this.$t("services-snackbar-t6");
            this.snackbar = true;

            this.cerrarDialog();
            this.listarServicios();
          })
          .catch((error) => {
            this.snackbar_text = this.$t("services-snackbar-t7");
            this.snackbar = true;
          });
      }
    },
    cerrarDialog() {
      this.dialog = false;

      this.limpiar();
    },
    limpiar() {
      this.flag_new_edit = 1;
      this.id_servicio = 0;
      this.cod_servicio = "";
      this.nom_servicio = "";
      this.activo = true;
      this.exento = false;
      this.no_sujeto = false;
      this.con_iva = true;
      this.precio = 0.0;
    },
    estadoExento() {
      if (this.exento) {
        this.no_sujeto = false;
        this.con_iva = false;
      }
    },

    estadoNoSujeto() {
      this.exento = false;
    },
    estadoIVA() {
      this.exento = false;
    },
  },
};
</script>